import React from "react";

const GlobalLanguageLoader = () => {
  return (
    <div className="fixed inset-0 z-[9999] bg-black/40 backdrop-blur-[1px] flex items-center justify-center">
      <div className="flex flex-col items-center gap-3 bg-white/90 px-6 py-4 rounded-lg shadow-lg">
        <div className="h-10 w-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
        <p className="text-sm text-gray-800 font-medium">
          Changing Language...
        </p>
      </div>
    </div>
  );
};

export default GlobalLanguageLoader;
